import { IGrid, IGridItem } from '@perxis-auto/ui-kit/lib/components/Grid/Grid.types';

function instanceOfGrid<Item extends IGridItem, Grid extends IGrid<Item>>(
  object: any,
): object is Grid {
  return 'items' in object;
}

export default instanceOfGrid;
